'use client';

import React, { useEffect, useState } from 'react';
import Image from 'next/image';

type Props = {
  src: string;
} & React.ComponentProps<typeof Image>;

const ImageWithFallback = ({ src, width, height, alt, ...rest }: Props) => {
  const [imgSrc, setImgSrc] = useState<string | undefined>(undefined);
  const fallbackSrc = 'https://placehold.co/155x155';
  useEffect(() => {
    if (!src) return;
    const isValidUrl = (url: string) => {
      try {
        new URL(url);
        return true;
      } catch (e) {
        return false;
      }
    };
    const isValidSrc = isValidUrl(src);
    if (!isValidSrc) {
      setImgSrc(fallbackSrc);
    } else {
      setImgSrc(src);
    }
  }, [src]);
  return (
    <>
      {imgSrc && (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          {...rest}
          alt={alt ?? 'Image'}
          src={imgSrc}
          width={+(width || 155)}
          height={+(height || 155)}
          onError={() => {
            setImgSrc(fallbackSrc);
          }}
        />
      )}
    </>
  );
};

export default ImageWithFallback;

type SkeletonProps = {
  className?: string;
};
export const ImageSkeleton = ({ className }: SkeletonProps) => {
  return <div className={`skeleton h-full ${className}`} />;
};
